import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import SEO from "../../UI/SEO/SEO";
import StartScreen from "./StartScreen";
export const getStartScreenBasePath = () => "/aviso/app/start";
export const getStartScreenBaseRoute = () => {
    return getStartScreenBasePath() + "/home";
};
const VirtualizedAppRoutes = () => (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Start Screen" }), _jsx(Switch, { children: _jsx(Route, { component: StartScreen, path: `${getStartScreenBasePath()}/home` }) })] }));
export default VirtualizedAppRoutes;
